import sentryTool from '@/sentry'

function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]'
}

function isEmptyObject(obj) {
  return (
    obj !== null &&
    typeof obj === 'object' &&
    !Object.keys(obj).length &&
    obj.constructor === Object
  )
}

function merge(data, defaultData) {
  const errKey = []
  for (const key in defaultData) {
    const item = defaultData[key]
    if (isObject(item) && !isEmptyObject(item)) {
      if (!data[key]) {
        errKey.push(key)
        data[key] = {}
      }
      const result = merge(data[key], item)
      data[key] = result.data
      errKey.push(...result.errKey)
      continue
    }
    if (!data[key]) {
      data[key] = item
      errKey.push(key)
    }
  }
  return {
    errKey,
    data
  }
}

function captureEvent(tag = null, otherInfo, errKey = []) {
  setTimeout(() => {
    sentryTool.captureEvent({
      message: '字段缺少',
      level: 'warning',
      extra: {
        tag,
        otherInfo,
        errKey: Array.from(new Set(errKey))
      }
    })
  })
}

/**
 *
 * @param data = []|{}
 * @param defaultData = {}
 * @param otherInfo  上报信息选填
 * @returns {[]|{}}
 */

export default function putIfAbsent(data, defaultData, otherInfo = {}) {
  if (!data || !(isObject(data) || Array.isArray(data))) {
    captureEvent(this && this.$vnode && this.$vnode.tag, otherInfo)
    console.error('data数据格式不正确')
    return []
  }
  if (!isObject(defaultData)) {
    throw new Error('defaultData不是一个对象')
  }
  let result = {}
  const errKey = []
  if (Array.isArray(data)) {
    result.data = data.map(item => {
      const itemResult = merge(item, defaultData)
      errKey.push(...itemResult.errKey)
      return itemResult.data
    })
  } else {
    result = merge(data, defaultData)
    errKey.push(...result.errKey)
  }

  if (errKey.length) {
    captureEvent(this && this.$vnode && this.$vnode.tag, otherInfo, errKey)
  }
  return result.data
}
